import { registerQuery } from 'data-fetching-client';
import { fetchBillingLimitData } from '../clients/fetchBillingLimitData';
export const FETCH_BILLING_LIMIT_DATA_QUERY_NAME = 'fetchBillingLimitData';
export const FETCH_BILLING_LIMIT_DATA_QUERY = registerQuery({
  fieldName: FETCH_BILLING_LIMIT_DATA_QUERY_NAME,
  fetcher: fetchBillingLimitData
});